<template>
    <section class="main-content pb-5">
        <div class="container-fluid">


<form class="form-horizontal form-profile fv-form fv-form-bootstrap"  @submit.prevent="processAccount">

    <div class="ibox float-e-margins">

      <div class="ibox-title">
        <h2>บัญชีผู้ใช้งาน</h2>
      </div>
      <div class="ibox-content">
        <div class="form-group has-feedback">
          <label class="col-lg-2 control-label">Username</label>
          <div class="col-lg-10">
            <input type="text" name="username" :placeholder="userData.username" disabled="disabled" class="form-control" id="username" data-fv-field="username"><i class="form-control-feedback" data-fv-icon-for="username" style="display: none;"></i>
          <small class="help-block" data-fv-validator="notEmpty" data-fv-for="username" data-fv-result="NOT_VALIDATED" style="display: none;">โปรดระบุข้อมูลในส่วนนี้</small><small class="help-block" data-fv-validator="stringLength" data-fv-for="username" data-fv-result="NOT_VALIDATED" style="display: none;">ค่าที่ระบุยังไม่ครบตามจำนวนที่กำหนด</small><small class="help-block" data-fv-validator="regexp" data-fv-for="username" data-fv-result="NOT_VALIDATED" style="display: none;">โปรดระบุค่าให้ตรงกับรูปแบบที่กำหนด</small></div>
        </div>
        
        <div class="form-group">
          <label class="col-lg-2 control-label">โทรศัพท์ติดต่อ</label>
          <div class="col-lg-10">
            <input type="text" name="mobile_show" class="form-control" :placeholder="userData.mobile_phone" disabled="disabled" id="mobile_show">
          </div>
        </div>

      </div>
    </div>

    <div class="ibox float-e-margins">
      <div class="ibox-title">
        <h2>บัญชีธนาคาร</h2>
      </div>
      <div class="ibox-content">
        <div class="form-group has-feedback">
          <label class="col-lg-2 control-label">ธนาคาร</label>
          <div class="col-lg-10">
            <input type="text" name="bank_id" class="form-control" :placeholder="bank_mapping[userData.bank_id]" disabled="disabled">
          </div>
        </div>
        <div class="form-group has-feedback">
          <label class="col-lg-2 control-label">ชื่อบัญชี</label>
          <div class="col-lg-10">
            <input type="text" name="bank_name" class="form-control" :placeholder="userData.bank_name" disabled="disabled">
          </div>
        </div>
        <div class="form-group has-feedback">
          <label class="col-lg-2 control-label">เลขที่บัญชี</label>
          <div class="col-lg-10">
            <input type="text" name="bank_account" class="form-control" :placeholder="userData.bank_account" disabled="disabled">
          </div>
        </div>

      </div>
    </div>

    <!-- Bottom area -->
    <!-- <div class="ibox float-e-margins bottom">
      <div class="ibox-content">
        <div class="form-group">
          <div class="col-lg-offset-2 col-lg-10">
            <button class="btn btn-primary" type="submit">ส่งข้อมูล</button>
          </div>
        </div>
      </div>
    </div> -->
    <!-- /.bottom -->
  </form>

  
  




        </div>
    </section>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: 'account',
    data () {
        return {
            creditAmount: 0,
            userData: {},

            bank_mapping: {
                "BBL":  'ธ.กรุงเทพ',
                "KBANK":  'ธ.กสิกรไทย',
                "KTB":  'ธ.กรุงไทย',
                "TMB": 'ธ.ทหารไทย',
                "SCB":  'ธ.ไทยพาณิชย์',
                "BAY":  'ธ.กรุงศรีอยุธยา',
                "KK":  'ธ.เกียรตินาคิน',
                "CIMB":  'ธ.ซีไอเอ็มบี',
                "TISCO":  'ธ.ทิสโก้',
                "TBANK":  'ธ.ธนชาต',
                "UOB": 'ธ.ยูโอบี',
                "SC":  'ธ.สแตนดาร์ดชาร์เตอร์ด (ไทย)',
                "TCD": 'ธ.ไทยเครดิตเพื่อรายย่อย',
                "LHB":  'ธ.แลนด์ แอนด์ เฮ้าส์',
                "ICBC":  'ธ.ไอซีบีซี (ไทย)',
                "BAAC":  'ธ.เพื่อการเกษตรและสหกรณ์การเกษตร',
                "GSB": 'ธ.ออมสิน',
                "GHB": 'ธ.อาคารสงเคราะห์',
                "IBANK":  'ธ.อิสลามแห่งประเทศไทย',
                "OTHER":  'ธ.อื่นๆ',
            }
        }
    },
    methods: {

        async processAccount () {
            //console.log('this account', this.user)
        },

        async loadUserData () {
            if ( !this.user) {
                return
            }

            try {
                const response = await this.$store.dispatch('user/getUserData', this.user.id)
                //console.log('loadUserData response: ', response)

                this.userData = response

                return this.userData

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

    },
    computed: {
        ...mapState({
            user: state => state.user.user,
        }),
        lastUpdate () {
            let now = new Date()
            return moment(now).format('DD/MM/YYYY HH:mm:ss')
        },
    },
    created () {
        //console.log('user', this.user)
        this.loadUserData()
    },
    destroyed () {
    }
}

</script>

<style lang="scss" scoped>
    @import '~@/assets/css/app.scss';

    .note-block {
        &__note {
            background: lighten($light-grey, 2%);
            padding: 10px;
            border-radius: 6px;
            margin-bottom: 20px;
            border: 1px solid $grey;

            &:hover {
                cursor: pointer;
                opacity: 0.8;
            }
        }
    }

</style>
